import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {User} from '../common/user';
import {DocumentsService} from '../common/documents.service';
import {SharedDocument} from '../common/shared-document';
import {ActivatedRoute, Router} from '@angular/router';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {UnityConnectTransaction} from '../common/model/unity-connect-transaction';
import {CirfService} from "../cirf/cirf.service";
import {Messages} from '../shared/messages';
import {NotificationService} from '../common/notification/notification.service';
import {IDUtil} from "../common/id-util";
import {MatterSummary} from '../common/model/matter-summary';
import {NavigationService} from '../navigation.service';
import {LockScreenService} from '../common/lock-screen.service';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SortDirection } from '@angular/material/sort/sort-direction';
import { Utils } from '../common/utils';
import { ConnectHomeListService } from './connect-home-list.service';
import {GlobalLoggerService} from '../common/logger/global-logger.service';
declare var jQuery : any;


@Component({
    selector: 'dp-connect-home-list',
    templateUrl: './connect-home-list.component.html',
    host: {
        '(window:resize)': 'onResize($event)'
    },
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({height: '0px', minHeight: '0'})),
            state('expanded', style({height: '*'})),
            transition('expanded <=> collapsed', animate('1225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})
export class ConnectHomeListComponent implements OnInit {
  user: User;
  documents: SharedDocument[] = [];
  message: string;
  routerState: any;
  tokens: string[] = [];
  expandedElement: MatterSummary | null;
  widthThresholdMed: number = 1000;
  widthThresholdMin: number = 700;

  @ViewChild('tableDiv') tableDiv : ElementRef;
  @ViewChild('backToTopBtn') backToTopBtn: ElementRef;

  defaultColumnsToDisplay: string[] = ['matterTypeName', 'matterAddressOrDescription', 'lawFirm', 'matterCloseDate'];

  matterSummaryList: MatterSummary[] = [];
  dataSourceMatterSummary: MatTableDataSource<MatterSummary>;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  searchText: string;

  constructor(private documentService: DocumentsService,
              private cirfService: CirfService,
              private route: ActivatedRoute,
              private  router: Router,
              private notificationService: NotificationService,
              private navigationService: NavigationService,
              public lockScreenService: LockScreenService,
              private matterSummaryService: ConnectHomeListService,
              private globalLoggerService: GlobalLoggerService) {
        this.routerState = this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras ? this.router.getCurrentNavigation().extras.state : undefined;
    }

    get columnsToDisplay(): string[] {
        if (window.innerWidth < this.widthThresholdMin) {
            const colsSmall: string[] = this.defaultColumnsToDisplay.filter(col => col !== 'matterCloseDate');
            colsSmall.unshift('expanded');
            return colsSmall;
        }
        return this.defaultColumnsToDisplay;
    }

  ngOnInit(): void {

    if (this.routerState && this.routerState.tokens) {
      this.tokens.push(...this.routerState.tokens);
    }
    this.cirfService.resetCirf();
    this.refreshList();
  }

    refreshList() {
        const startTime = performance.now();
        this.lockScreenService.lockScreen = true;
        this.documentService.getAllTransactionsForCurrentUser()
            .subscribe(
                (unityConnectTrasactionsResponse) => {
                    if (Array.isArray(unityConnectTrasactionsResponse)) {
                        this.globalLoggerService.logDuration(startTime, 'getAllTransactionsForCurrentUser' );
                        this.matterSummaryList = [];
                        unityConnectTrasactionsResponse.forEach( ucts => this.addTransactionToMatterSummaryList(ucts));
                        this.dataSourceMatterSummary = new MatTableDataSource(this.matterSummaryList);
                        let sessionSearchText = this.matterSummaryService.searchText;
                        let sortColumn = this.matterSummaryService.sortColumn;
                        let sortOrder : SortDirection = this.matterSummaryService.sortOrder;
                        if(!Utils.isNotNullorUndefined(sortColumn)){
                            sortColumn = 'matterCloseDate';
                        }
                        if(!Utils.isNotNullorUndefined(sortOrder)){
                            sortOrder= 'desc';
                        }
                        //function used to filter the home list table
                        this.dataSourceMatterSummary.filterPredicate = function(data: MatterSummary, filter: string): boolean {
                            let result = false;
                            for (let i = 0; i < data.transactions.length; i++) {
                                let transaction =  data.transactions[i];
                                if(transaction.searchTerms.findIndex(element => element.toLowerCase().includes(filter)) != -1) {
                                    result = true;
                                    break;
                                }
                            }
                            return result;
                        };

                        if(Utils.isNotNullorUndefined(sessionSearchText)){
                            this.searchText = sessionSearchText;
                            this.applyFilterMatterSummary();
                        }
                        this.dataSourceMatterSummary.sort = this.sort;
                        const sortState: Sort = {active: sortColumn, direction: sortOrder };
                        this.sort.active = sortState.active;
                        this.sort.direction = sortState.direction;
                        this.sort.sortChange.emit(sortState);
                        this.focusFirstRow();
                    }
                })
            .add( () => {this.lockScreenService.lockScreen = false;});
    }

    focusFirstRow(): void {
        setTimeout(() => {
            jQuery('.mat-table').find('tbody tr:first').focus();
        }, 500)
    }

    addTransactionToMatterSummaryList(uct: UnityConnectTransaction) {
        if (uct.matterId) {
            const existingMatterSummary: MatterSummary = this.matterSummaryList.find(msl => msl.matterId === uct.matterId);
            if (existingMatterSummary) {
                if (uct.isParticipantCirf()) {
                    let index: number = existingMatterSummary.transactions.findIndex(uct => uct.isMatterCirf() && uct.isCancelled());
                    if (index > -1) { //if existing matter cirf that's canceled, remove the cancelled matter cirf from list
                        existingMatterSummary.transactions.splice(index,1);
                    }
                } else if (uct.isMatterCirf() && uct.isCancelled() && existingMatterSummary.transactions.some(uct => uct.isParticipantCirf())) {
                    return; //don't add cancelled matter Cirfs to list when there is an existing participant cirf
                }

                existingMatterSummary.transactions.push(uct);
                return;
            }
        }
        const matterSummary = new MatterSummary();
        matterSummary.matterId = uct.matterId;
        matterSummary.matterCloseDate = uct.matterCloseDate;
        matterSummary.matterAddressOrDescription = uct.matterAddressOrDescription;
        matterSummary.matterType = uct.matterType;
        matterSummary.matterTypeName = uct.matterTypeName;
        matterSummary.lawFirm = uct.lawFirm;
        matterSummary.transactions.push(uct);
        this.matterSummaryList.push(matterSummary);
    }

    onResize(event) {
        if (event.target.innerWidth > this.widthThresholdMin) {
            this.expandedElement = null;
        }
    }

    setExpandedElement(element: MatterSummary, event): void {
        this.expandedElement = this.expandedElement === element ? null : element;
        event.stopPropagation();
        event.preventDefault();
    }

    createReferral(): void {
        let id = -(IDUtil.getID());
        this.saveTableState();
        this.router.navigate(['./home/referral/' + id]);
    }

    navigateTo(matterSummary: MatterSummary) {
        if (!matterSummary) {
            this.notificationService.showNotification(Messages.invalidMatterSummarySelected, 'error');
        }
        else if (matterSummary && matterSummary.transactions.length > 0) {
         this.saveTableState();
         this.router.navigate(['./home/matter-summary-home'], {state: {transactions: matterSummary.transactions}});
        }
    }

    get transactionTypeHeader(): string {
        if (window.innerWidth < this.widthThresholdMed) {
            return 'Type';
        }
        return 'Transaction Type';
    }

    get transactionDateHeader(): string {
        if (window.innerWidth < this.widthThresholdMed) {
            return 'Date';
        }
        return 'Transaction Date';
    }

    applyFilterMatterSummary(){
        let filterValue = this.searchText.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
        this.dataSourceMatterSummary.filter = filterValue;
    }

    saveTableState() {
      this.matterSummaryService.searchText = this.searchText;
      this.matterSummaryService.sortOrder = this.sort.direction;
      this.matterSummaryService.sortColumn = this.sort.active;
    }

    onScrollEvent() {
        Utils.toggleBackToTopBtnVisibility(this.tableDiv, this.backToTopBtn)
    }

    backToTop() {
        Utils.backToTop(this.tableDiv);
    }

}

